import { get, post } from "helpers/api_helper";
import { API_AUTH_SIGNIN, API_GET_USER_INFO } from "helpers/url_helper";

export const apiLogin = (body) => {
  return post(API_AUTH_SIGNIN, body);
};

export const apiGetUserInfo = () => {
  return get(API_GET_USER_INFO);
};
